<template>
  <ts-panel>
    <ts-panel-wrapper class="tw-space-y-2">
      <h1 class="section-divider-underline">
        {{ $t("examRegister.courseSkill") }}
      </h1>
      <div class="row tw-space-y-4">
        <div class="col-md-12 tw-space-y-2">
          <label class="form-col-label control-label">{{
            $t("examRegister.courseSkill")
          }}</label>
          <a-select
            class="col-md-12"
            show-search
            option-filter-prop="children"
            allowClear
            placeholder="Examination event|Trainer|Exam Date"
            v-model="model.course_skill_id"
            :class="{
              'is-invalid': errors.has('course_skill_id'),
            }"
            @change="onExamEventChange"
          >
            <a-select-option
              v-for="(courseSkill, index) in formViewDatas['courseSkills']"
              :key="index"
              :value="courseSkill.course_skill_id"
            >
              Skill Test: {{ courseSkill.examination_event }} | Skill Level:
              {{ courseSkill.levelskill.level_skill_name }} |
              {{ courseSkill.trainer.full_name_en }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('course_skill_id')">
            {{ errors.first("course_skill_id") }}
          </div>
        </div>

        <div class="col-md-12 tw-flex tw-content-between">
          <div class="col-md-4 tw-pr-3">
            <label class="form-label col-form-label col-md-12 required">{{
              $t("examRegister.examDate")
            }}</label>
            <a-date-picker
              v-model="model.exam_date"
              style="width: 100%"
              placeholder="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              format="DD-MM-YYYY"
              @change="onChangeExamDate"
              :class="{
                'is-invalid': errors.has('course_skill_id'),
              }"
            />
            <div class="invalid-feedback" v-if="errors.has('exam_date')">
              {{ errors.first("exam_date") }}
            </div>
          </div>
          <div class="col-md-4 tw-px-1.5">
            <label class="form-label col-form-label col-md-12 required">{{
              $t("examRegister.timeStart")
            }}</label>
            <a-time-picker
              v-model="model.time_start"
              style="width: 100%"
              placeholder="H:mm"
              valueFormat="h:mm a"
              format="h:mm a"
              @change="onChangeTimeStart"
              :class="{
                'is-invalid': errors.has('course_skill_id'),
              }"
            />
            <div class="invalid-feedback" v-if="errors.has('exam_date')">
              {{ errors.first("exam_date") }}
            </div>
          </div>
          <div class="col-md-4 tw-pl-3">
            <label class="form-label col-form-label col-md-12 required">{{
              $t("examRegister.timeStop")
            }}</label>
            <a-time-picker
              v-model="model.time_stop"
              style="width: 100%"
              placeholder="H:mm"
              valueFormat="h:mm a"
              format="h:mm a"
              @change="onChangeTimeStop"
              :class="{
                'is-invalid': errors.has('course_skill_id'),
              }"
            />
            <div class="invalid-feedback" v-if="errors.has('exam_date')">
              {{ errors.first("exam_date") }}
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <label class="form-label col-form-label col-md-12">{{
            $t("search")
          }}</label>
          <div class="col-md-12">
            <input type="text" v-model="search" class="form-control" />
          </div>
        </div>
        <h1 class="section-divider-underline">
          {{ $t("examRegister.candidate") }}
        </h1>
        <div
          class="tw-overflow-y-scroll col-12 tw-h-96"
          style="max-height: 50vh"
        >
          <ts-loading-banner :loading="loading">
            <table class="tw-w-full">
              <thead>
                <tr
                  class="tw-uppercase tw-bg-gray-200 tw-h-10 tw-sticky tw-top-0"
                >
                  <!-- <th style="width: 20%" class="tw-pl-2">
                    {{ $t("examRegister.cardNumber") }}
                  </th> -->
                  <th style="width: 25%" class="tw-pl-2 tw-whitespace-no-wrap">
                    {{ $t("examRegister.nameEn") }}
                  </th>
                  <th
                    style="width: 15%"
                    class="tw-text-center tw-whitespace-no-wrap"
                  >
                    {{ $t("examRegister.sex") }}
                  </th>
                  <th style="width: 20%" class="tw-whitespace-no-wrap">
                    {{ $t("examRegister.registerDate") }}
                  </th>
                  <th style="width: 15%" class="tw-whitespace-no-wrap">
                    {{ $t("examRegister.phone") }}
                  </th>
                  <th style="width: 5%"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    v-if="!formViewDatas['candidates'][0]"
                    colspan="5"
                    class="tw-text-center tw-h-10"
                  >
                    No Data
                  </td>
                </tr>
                <tr
                  v-for="(candidate, index) in candidates({
                    candidateRegisted: model.candidateRegisted,
                  })"
                  :key="index"
                  class="
                    tw-cursor-pointer
                    hover:tw-bg-gray-300
                    tw-w-full tw-h-10
                  "
                  @click="addNew(candidate)"
                >
                  <!-- <td class="tw-whitespace-no-wrap tw-pl-2">
                    {{ candidate.card_number }}
                  </td> -->
                  <td class="tw-whitespace-no-wrap tw-pl-2">
                    {{ candidate.full_name_en }}
                  </td>
                  <td class="tw-whitespace-no-wrap tw-text-center">
                    {{ candidate.sex }}
                  </td>
                  <td class="tw-whitespace-no-wrap">
                    {{ candidate.register_date }}
                  </td>
                  <td class="tw-whitespace-no-wrap">
                    {{ candidate.phone }}
                  </td>
                  <td
                    class="
                      tw-whitespace-no-wrap tw-text-green-500 tw-text-center
                    "
                  >
                    <a-icon type="plus-circle" class="tw-text-lg" />
                  </td>
                </tr>
              </tbody>
            </table>
          </ts-loading-banner>
        </div>
      </div>
    </ts-panel-wrapper>
  </ts-panel>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapGetters, mapState } from "vuex";
import { debounce } from "lodash";

export default {
  name: "exam-schedule",
  props: ["value", "validation"],
  data() {
    return {
      search: "",
      loading: false,
      model: {},
      errors: new Errors(),
      options: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("academic/examRegister", ["formViewDatas", "edit_data"]),
    ...mapGetters("academic/examRegister", ["candidates"]),
  },
  methods: {
    ...mapActions("academic/examRegister", ["getFormViewData"]),
    onChangeExamDate(dateString) {
      this.model.exam_date = dateString;
    },
    onChangeTimeStart(dateString) {
      this.model.time_start = dateString;
    },
    onChangeTimeStop(dateString) {
      this.model.time_stop = dateString;
    },
    async onExamEventChange() {
      this.model.candidate_list = [];
      this.model.candidateRegisted = [];
      this.$emit("clearError");
      this.search = "";
      this.loading = true;
      await this.getFormViewData({
        index: "candidates",
        params: {
          fnName: "candidates",
          course_skill_id: this.model.course_skill_id,
        },
      });
      this.setEditData();
      this.loading = false;
    },
    async onSearchChange() {
      // this.model.candidate_list = [];
      this.loading = true;
      await this.getFormViewData({
        index: "candidates",
        params: {
          fnName: "candidates",
          course_skill_id: this.model.course_skill_id,
          searchCandidate: this.search,
        },
      });
      this.loading = false;
    },
    addNew(candidate) {
      this.model.candidate_list.push(candidate.candidate_id);
      this.model.candidateRegisted.push({
        candidate_id: candidate.candidate_id,
        full_name_en: candidate.full_name_en,
        card_number: candidate.card_number,
        phone: candidate.phone,
        register_date: candidate.register_date,
        sex: candidate.sex,
      });
    },
    clearOption() {
      this.model.status_reason_id = null;
      this.options = null;
    },
    setEditData() {
      let course = this.formViewDatas["courseSkills"].find(
        (e) => e.course_skill_id == this.model.course_skill_id
      );
      this.model.exam_date = course["exam_date"];
      this.model.time_start = course["time_start"];
      this.model.time_stop = course["time_stop"];
    },
  },
  watch: {
    search: debounce(function () {
      this.onSearchChange();
    }, 500),
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
